module.exports = __webpack_public_path__ + "img/img5.3691135d.png";